import { GetProductCollectionApiV2Parameter, GetRelatedProductCollectionApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSelectedProductPath } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getProductStateByPath } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { getDataView } from "@store/Store/Data/DataState";
import StoreApplicationState from "@store/Store/StoreApplicationState";

export const getProductState = (state: ApplicationState) => {
    const location = getLocation(state);
    const productPath =
        getSelectedProductPath(state) ||
        (location.pathname.toLowerCase().startsWith("/content/") ? "" : location.pathname);
    return getProductStateByPath(state, productPath);
};

export const getProduct = (state: ApplicationState) => {
    const productState = getProductState(state);
    if (productState) {
        return productState.value;
    }
};

export function getProductsDataView(
    state: StoreApplicationState,
    getProductsParameter?: GetProductCollectionApiV2Parameter | GetRelatedProductCollectionApiV2Parameter,
) {
    return getDataView(state.data.products, getProductsParameter);
}
